import { render, staticRenderFns } from "./ExchangeFooterMenu.vue?vue&type=template&id=c2742fe0&"
import script from "./ExchangeFooterMenu.vue?vue&type=script&lang=js&"
export * from "./ExchangeFooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeFooterMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports